import InputForm from '../InputForm';
import React from 'react';

const InputWonForm = (props) => {
  const { form, name, label, isEditable, initialValue, rules, min = 0, max, step = 10, ...res } = props;

  return (
    <InputForm
      label={label}
      form={form}
      name={name}
      type="number"
      isEditable={isEditable}
      step={step}
      rules={rules}
      min={min}
      max={max}
      formatter={(value) => `${value}원`}
      parser={(value) => value.replace('원', '')}
      unit="원"
      initialValue={initialValue}
      {...res}
    />
  );
};

export default InputWonForm;
